import type { OvernightFees } from '../utils/DxtradeCashTransfersFields'
import { useDxtradeOrderCashAdjustments } from './useDxtradeOrderCashAdjustments'
import { useHistoryOrderPnl } from './useHistoryOrderPnl'
import type { HistoryOrderWithLots } from './useHistoryOrdersWithLots'

export function useOrderNetPnl(
  order: HistoryOrderWithLots,
  overnightFees?: OvernightFees | null
): number | undefined {
  const pnl = useHistoryOrderPnl(order)
  const { commission } = useDxtradeOrderCashAdjustments(order)

  if (!pnl) return undefined

  return pnl + (commission?.total ?? 0) * 2 + (overnightFees?.total ?? 0)
}
